import React, {useEffect, useState } from "react";
import {motion} from "framer-motion";

import { WeatherCard } from "../components/WeatherApp";
import { FlexRow, Text } from "../components";

const WeatherApp = () =>
{

    const [data, setWeatherData] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchParams = { 
        locations: [
            {
                city: "London",
                country: "Canada"
            },
            {
                city: "Hamilton",
                country: "Canada"
            },
            {
                city: "Waterloo",
                country: "Canada"
            },
            {
                city: "Toronto",
                country: "Canada"
            },
            {
                city: "Mexico City",
                country: "Mexico"
            },

        ],
        key: "7fd8cbb36fe30c75d0cb9beff644a9de"
    };

    useEffect( () => {
        const fetchData = async () => {

            //fetch from api
            const key = fetchParams.key;
            let weatherData = [];

            for (let i=0; i < fetchParams.locations.length; i++ )
            {
                const url = `https://api.openweathermap.org/data/2.5/weather?q=${fetchParams.locations[i].city},${fetchParams.locations[i].country}&units=metric&appid=${key}`;
                const res = await fetch(url);
                weatherData.push( await res.json() );
            }
            
            setWeatherData(weatherData);
            setLoading(false);
        };

        fetchData();
    }, []);

    return (
        <motion.div 
            initial={{ opacity: 0}}
            animate={{opacity: 1}}
            exit={{opacity: 0}} 
        >

            <FlexRow style={ {
                flexWrap: "wrap",
                margin: "5rem auto 0 auto",
                justifyContent: "center"
            }} >
            { 
                (data === []) ? <p>Fetching...</p> : (
                    
                    data.map( (location) => {
                        return ( <WeatherCard location={location} ></WeatherCard>)
                    })
                )
            }
            </FlexRow>

            <Text style={{textAlign: "center", color: "#333333"}}>Sergio Cosman Agraz 2022</Text>
            
        </motion.div>
    )
}

WeatherApp.defaultProps = {};

export default WeatherApp;